export * from './FavoritesWidget';
export { default } from './FavoritesWidget';
